import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
export var PrivateRoute = function () {
    var isAuthenticated = useSelector(function (state) { return state.auth; }).isAuthenticated;
    return isAuthenticated ? _jsx(Outlet, {}) : _jsx(Navigate, { to: '/login' });
};
